import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';
import { TransactionFlow } from './enums/TransactionFlow';
import { TransactionGroup } from './enums/TransactionGroup';

export class WalletTransactionsPaginated {
  @Type(() => WalletTransactionItem)
  items: WalletTransactionItem[];

  @Expose({ name: 'next_page_url' })
  nextPageUrl?: string;

  @Expose({ name: 'transaction_labels' })
  transactionLabels?: Record<string, string>;

  @Expose({ name: 'transaction_keys' })
  transactionKeys?: string[];

  constructor(
    items: WalletTransactionItem[],
    nextPageUrl?: string,
    transactionLabels?: Record<string, string>,
    transactionKeys?: string[]
  ) {
    this.items = items;
    this.nextPageUrl = nextPageUrl;
    this.transactionLabels = transactionLabels;
    this.transactionKeys = transactionKeys;
  }

  get cursor(): string | null {
    return this.nextPageUrl
      ? new URL(this.nextPageUrl).searchParams.get('cursor')
      : null;
  }

  static fromJson(json: Record<string, any>): WalletTransactionsPaginated {
    return plainToInstance(WalletTransactionsPaginated, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class WalletTransactionItem {
  id: number;

  @Expose({ name: 'transaction_group' })
  group: TransactionGroup;

  @Expose({ name: 'transaction_type' })
  type: string;

  @Expose({ name: 'transaction_key' })
  key: string;

  amount: string;

  @Expose({ name: 'cash_flow' })
  flow: TransactionFlow;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  dateCreated: Date;

  level?: number;

  @Expose({ name: 'from_user' })
  fromUser?: string;

  @Expose({ name: 'rank_name' })
  rankName?: string;

  constructor(
    id: number,
    group: TransactionGroup,
    type: string,
    key: string,
    amount: string,
    flow: TransactionFlow,
    dateCreated: Date,
    level?: number,
    fromUser?: string,
    rankName?: string
  ) {
    this.id = id;
    this.group = group;
    this.type = type;
    this.key = key;
    this.amount = amount;
    this.flow = flow;
    this.dateCreated = dateCreated;
    this.level = level;
    this.fromUser = fromUser;
    this.rankName = rankName;
  }

  static fromJson(json: Record<string, any>): WalletTransactionItem {
    return plainToInstance(WalletTransactionItem, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
